import { render } from "./TeamsList.vue?vue&type=template&id=bf011796&scoped=true"
import script from "./TeamsList.vue?vue&type=script&lang=js"
export * from "./TeamsList.vue?vue&type=script&lang=js"

import "./TeamsList.vue?vue&type=style&index=0&id=bf011796&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf011796"]])

export default __exports__